import { motion } from "framer-motion";
import { useTheme } from "../lib/theme";

const Sun = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5"><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></svg>
);
const Moon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" /></svg>
);

export const ThemeSwitch = () => {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      type="button"
      role="switch"
      aria-checked={dark}
      data-testid="theme-switch"
      title={dark ? "Switch to light mode" : "Switch to dark mode"}
      aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
      onClick={toggle}
      className="theme-switch-track shrink-0"
    >
      <motion.span
        className="theme-switch-orb"
        animate={{ left: dark ? 3 : 30, scale: [1, 0.88, 1] }}
        transition={{ duration: 0.35, ease: [0.32, 0.72, 0, 1] }}
      >
        {dark ? <Moon /> : <Sun />}
      </motion.span>
    </button>
  );
};
